<template>
  <div class="col-md-11 visits__items">
    <div v-if="inLoading === true" class="text-center mt-5 d-flex justify-content-center">
      <b-spinner
          variant="primary"
      ></b-spinner>
    </div>
    <div v-if="inLoading === false && (consultationsVisitPast === 0 || consultationsVisitPast.length === 0)">
      <div class="not-found row mt-5">
        <div class="col-3 d-flex justify-content-end">
          <img src="~@/assets/images/zero-illu-01.svg" alt="">
        </div>
        <div class="col-7">
          <div class="mb-3" v-html="$t('consultations.empty.text')">
          </div>

          <router-link :to="{name:'profile.order.find-doctor'}" class="btn w-auto">
            {{
              $t('consultations.empty.button')
            }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="visits__item row"
         v-if="inLoading === false"
         v-for="consultationVisitPast in consultationsVisitPast"
         :class='{ "read": consultationVisitPast.read }'>
      <i class="fa fa-check" aria-hidden="true"></i>

      <div class="date col-3">
        {{ formatDate(consultationVisitPast.date_time) }}
        <span> {{ formatTime(consultationVisitPast.date_time) }}</span>
      </div>
      <div class="text name col-2">
        {{ consultationVisitPast.service_type.title }}
      </div>

      <div class=" col-5 d-flex flex-row flex-nowrap">
        <div class="avatar"
             :style="getDoctorAvatarUrl(consultationVisitPast.doctor.odrex_id) ? `background-image:url(${getDoctorAvatarUrl(consultationVisitPast.doctor.odrex_id)})`:''"
             :class="!getDoctorAvatarUrl(consultationVisitPast.doctor.odrex_id) ? 'avatar-placeholder':''"></div>
        <span>
              {{ getFirstName(consultationVisitPast.doctor.name) }}<br>
              {{ getOtherName(consultationVisitPast.doctor.name) }}
        </span>
      </div>
      <div class="col-2 d-flex">
        <button class="icon__info" @click="openDocumentModal(consultationVisitPast)"></button>

        <button v-if="consultationVisitPast.service_type.can_be_ordered" class="btn btn-link-clear btn-icon"
                @click="reOrder(consultationVisitPast)">
          <i class="fa fa-repeat" aria-hidden="true"></i>
        </button>

      </div>

      <div class="delimiter w-100"></div>
    </div>

    <b-modal ref="documentModal" centered size="lg" hide-footer title="Документ">
      <div class="loading w-100 d-flex justify-content-center" v-if="selectedVisitPastContentLoading">
        <b-spinner
            variant="primary"
        ></b-spinner>
      </div>
      <iframe class="content w-100 h-auto" style="min-height: 500px" ref="selectedVisitPastDocument"></iframe>

      <div class="mt-3">
        <button class="btn-blue mr-1" v-if="selectedVisitPastContent" @click="downloadDocument()">
          {{ $t('buttons.download') }}
        </button>
        <button class="btn-blue" @click="hideDocumentModal()">{{ $t('buttons.hide') }}</button>
      </div>
    </b-modal>

    <b-modal ref="reorderModal" centered size="md" hide-footer title="Уведомление">
      <div class="content">
        Извините, повторная запись на прием к данному доктору невозможна.<br>
        Для записи обратитесь в call-центр по номеру:<br>
        <a href="tel:+380487300030">
          +38 (048) 730-00-30
        </a>
      </div>

      <div class="mt-3">
        <button class="btn-blue" @click="hideReorderModal()">Закрыть</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import fileSave from '@/helpers/fileSave';
import config from '@/helpers/configDateFormats';

export default {
  name: 'consultations-past',
  data() {
    return {
      selectedVisitPast: null,
      selectedVisitPastContentLoading: false,
      selectedVisitPastContent: null,
    };
  },
  computed: {
    ...mapGetters({
      consultationsVisitPast: 'consultationsPast',
      doctors: 'doctors',
      inLoading: 'isConsultationsInLoading',
    }),
  },
  methods: {
    reOrder(consultationVisit) {
      if (consultationVisit.doctor.odrex_id && consultationVisit.service_type.id) {
        let query = {
          doctor_id: consultationVisit.doctor.odrex_id,
          specialization_id: consultationVisit.service_type.id,
        };

        if (consultationVisit.clinic) {
          query = {
            ...query,
            clinic_id: consultationVisit.clinic.id,
          };
        }

        this.$router.push({
          name: 'profile.order.choose-doctor-time-table',
          query,
        })
      } else {
        this.$refs.reorderModal.show();
      }
    },
    getDoctorAvatarUrl(doctor_id) {
      let doctor = this.doctors.filter((doctor) => doctor.odrex_id === doctor_id)
      if (doctor.length > 0) {
        return doctor[0].image
      }
      return null
    },
    hideReorderModal() {
      this.$refs.reorderModal.hide();
    },
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    formatTime(date) {
      return moment(date).format(config.TIME_FORMAT);
    },
    getFirstName(name) {
      const [last_name = '', first_name = '', second_name = ''] = name.split(' ');
      return first_name;
    },
    getOtherName(name) {
      const [last_name = '', first_name = '', second_name = ''] = name.split(' ');
      return [last_name, second_name].join(' ');
    },
    openDocumentModal(visitPast) {
      this.selectedVisitPastContent = null;
      this.selectedVisitPastContentLoading = true;
      if (this.$refs.selectedVisitPastDocument) {
        this.$refs.selectedVisitPastDocument.src = '';
      }
      this.selectedVisitPast = visitPast;
      this.$refs.documentModal.show();
      this.$store
          .dispatch('getVisitDocument', {visit_id: visitPast.id})
          .then(content => {
            this.selectedVisitPastContent = content;
            this.selectedVisitPastContentLoading = false;
            let byteCharacters = atob(content.data);
            let byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            let file = new Blob([byteArray], {type: 'application/pdf;base64'});
            this.$refs.selectedVisitPastDocument.src = URL.createObjectURL(file);

            this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']});
          })
    },
    hideDocumentModal() {
      this.$refs.documentModal.hide();
      this.selectedVisitPastContent = null;
      this.$refs.analyzeContent.src = '';
    },
    downloadDocument() {
      if (this.selectedVisitPastContent) {
        let byteCharacters = atob(this.selectedVisitPastContent.data);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        fileSave({
          blob: byteArray,
          type: 'application/pdf',
          name: this.selectedVisitPast.doctor_name,
        });
      }
    },
  },
}
</script>
